"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPropertyExchangePositive = function SvgBPropertyExchangePositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M120.395 122.14a2.139 2.139 0 01.031-4.277l13.462-.036a2.139 2.139 0 01.011 4.279l-13.462.036-.042-.001z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M117.407 135.635a2.139 2.139 0 01-2.102-2.125c.021-1.226.711-1.942 2.133-2.102v-.036l.25.005.463.008 13.926-.092-.088-28.008a2.139 2.139 0 014.278-.01l.08 30.103a2.139 2.139 0 01-2.119 2.144l-16.757.114h-.064zM83.718 135.66a2.139 2.139 0 01-2.102-2.132l-.08-30.111a2.139 2.139 0 014.278-.01l.053 28.013 21.39.003a2.139 2.139 0 11.003 4.278l-23.528.002-.014-.043z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M70.09 71.753a2.139 2.139 0 01-2.102-2.132l-.067-23.58a2.139 2.139 0 012.134-2.144l11.18-.026a.15.15 0 00.166-.111.164.164 0 00-.04-.2L41.416 3.847A2.148 2.148 0 1144.462.82L84.41 40.532a4.455 4.455 0 01-3.127 7.617l-9.041.02.053 21.441a2.139 2.139 0 01-2.133 2.145l-.072-.002z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M16.178 71.896a2.139 2.139 0 01-2.101-2.133l-.054-21.44-9.162.025a4.434 4.434 0 01-3.155-7.562L34.741 7.574a2.14 2.14 0 013.034 3.02L4.741 43.803a.121.121 0 00-.04.171c.042.1.099.102.149.095l11.301-.03a2.139 2.139 0 012.145 2.133l.053 21.44 15.915-.043-.055-21.39c-.004-.567.221-1.11.626-1.508a2.139 2.139 0 011.508-.637l13.547-.034a2.139 2.139 0 012.145 2.134l.054 21.39 7.893-.012a2.14 2.14 0 01.01 4.278l-10.046.024a2.139 2.139 0 01-1.53-.597 2.139 2.139 0 01-.629-1.515l-.061-21.39-9.27.023.055 21.39a2.139 2.139 0 01-2.133 2.145l-20.193.054-.007-.029z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M76.939 102.118a2.139 2.139 0 01-1.827-3.19L88.58 75.22a2.142 2.142 0 113.72 2.126L80.658 97.819l60.27-.16a2.14 2.14 0 01.012 4.278l-63.957.167-.043.014z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M135.042 91.767a2.139 2.139 0 01-1.814-1.073l-7.12-12.38-25.719.071a2.139 2.139 0 01-.01-4.278l26.958-.071c.767 0 1.475.409 1.857 1.073l7.736 13.454a2.139 2.139 0 01-.764 2.924c-.342.195-.73.292-1.124.28zM117.407 135.635a2.139 2.139 0 01-2.102-2.133l-.088-32.128a2.139 2.139 0 014.278-.01l.088 32.127a2.139 2.139 0 01-2.133 2.145h-.043z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M97.097 115.46a2.139 2.139 0 01.032-4.277l6.766-.018a2.139 2.139 0 01.011 4.278l-6.766.018-.043-.001z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M120.517 51.408a2.139 2.139 0 01-2.102-2.133l-.015-9.333a12.119 12.119 0 00-12.188-12.105l-12.663.036a2.139 2.139 0 01-.01-4.279l12.663-.035a16.396 16.396 0 0116.447 16.379l.016 9.326a2.139 2.139 0 01-2.134 2.144h-.014z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M100.277 34.585a2.139 2.139 0 01-1.472-.617l-6.742-6.72a2.139 2.139 0 01-.004-3.023l6.755-6.756a2.139 2.139 0 013.021 3.005l-5.232 5.234 5.22 5.204c.836.834.838 2.187.005 3.023-.406.42-.967.654-1.551.65z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M40.394 122.356c-8.935-.155-16.101-7.437-16.112-16.374l-.023-9.326a2.139 2.139 0 014.278-.01l.023 9.326a12.119 12.119 0 0012.151 12.111l12.664-.064a2.139 2.139 0 11.011 4.278l-12.663.029-.329.03z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M46.587 129.073a2.139 2.139 0 01-1.476-3.648l5.239-5.234-5.222-5.168a2.14 2.14 0 013.02-3.034l6.74 6.72c.836.834.838 2.187.005 3.023l-6.762 6.72c-.41.406-.966.63-1.544.621z",
    fill: "#1B7"
  })));
};

var _default = SvgBPropertyExchangePositive;
exports["default"] = _default;